import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Select from "react-select";
import * as codeActions from "../../actions/codeActions";

const ProjectStatusSelect = ({
  value: initialValue,
  isMulti = false,
  onChange,
  codes = [],
  actions,
  placeholder,
  label,
  disabled
}) => {
  if (!codes.length) {
    actions.loadCodes();
  }

  const options = codes
    .filter((code) => code.entity === "Project" && code.field === "status")
    .map((d) => ({
      label: d.label,
      value: d._id
    }));

  const value =
    isMulti && Array.isArray(initialValue)
      ? options.filter((x) => initialValue.includes(x.value))
      : initialValue;

  return (
    <React.Fragment>
      {label ? (
        <label
          className={`control-label ${!label ? "hidden" : ""}`}
          htmlFor="project-status-type-select"
          style={{ textTransform: "uppercase" }}
        >
          {label}
        </label>
      ) : null}
      <Select
        name="project-status-type-select"
        id="project-status-type-select"
        className="react-select-container"
        classNamePrefix="react-select-container"
        fullwidth
        placeholder={placeholder}
        value={value}
        options={options}
        isClearable
        onChange={onChange}
        isMulti={isMulti}
        isDisabled={disabled}
      />
    </React.Fragment>
  );
};

ProjectStatusSelect.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  codes: PropTypes.array,
  actions: PropTypes.object,
  isMulti: PropTypes.bool,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  disabled: PropTypes.bool
};

ProjectStatusSelect.defaultProps = {
  placeholder: "Project Status",
  disabled: false
};

function mapStatesToProps(state) {
  return {
    codes: state.reducers.codes
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...codeActions
      },
      dispatch
    )
  };
}

export default connect(
  mapStatesToProps,
  mapDispatchToProps
)(ProjectStatusSelect);
